import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BudgetService } from '../../../../../services/budget.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { BudgetCategory } from '../../../../../models/budget-category.model';
import { Location } from '@angular/common';

@Component({
  selector: 'app-budget-parameter-register',
  templateUrl: './budget-parameter-register.component.html',
  styleUrl: './budget-parameter-register.component.scss'
})
export class BudgetParameterRegisterComponent {
  categoryForm!: FormGroup;
  breadCrumbItems: Array<{}> = [];
  loading: boolean = false;

  constructor(
    private location: Location,
    private budgetService: BudgetService,
    private toastService: ToastService,
    private fb: FormBuilder) {

    this.breadCrumbItems = [
      { label: "Parâmetros Orçamento" },
      { label: "Cadastrar", active: true },
    ];

    this.categoryForm = this.fb.group({
      nome: ["", [Validators.required]],
      apresentarEmOrcamento: [],
      tipoDeCalculo: ["", [Validators.required]],
      tipoDeApresentacao: ['1', Validators.required],
      tipoDeDespesa: ['1']
    });
  }
  
  onSubmit() {
    if (this.categoryForm.invalid) {
      this.categoryForm.markAllAsTouched();
      return;
    }

    this.loading = true;

    var category = new BudgetCategory();
    category.nome = this.categoryForm.get('nome')?.value;
    category.apresentarEmOrcamento = this.categoryForm.get('apresentarEmOrcamento')?.value;
    category.tipoDeCalculo = parseInt(this.categoryForm.get('tipoDeCalculo')?.value);
    category.tipoDeApresentacao = this.categoryForm.get('apresentarEmOrcamento')?.value? parseInt(this.categoryForm.get('tipoDeApresentacao')?.value) : 0;
    category.tipoDeDespesa = parseInt(this.categoryForm.get('tipoDeDespesa')?.value)

    this.budgetService.registerBudgetcategory(category).subscribe({
      next: (data) => {

        this.toastService.show("Cadastro com sucesso!", {
          classname: "bg-success text-light",
        });

        this.categoryForm.reset({
          tipoDeDespesa: '1'
        });

        this.loading = false;
      },
      error: (err) => {
        this.toastService.show("Erro ao tentar cadastrar documento!", {
          classname: "bg-danger text-light",
        });
        this.loading = false;
      }
    });
  }

  voltar() {
    this.location.back();
  }
}
